<template>
  <in-viewport>
    <div class="worked-section">
      <base-layout>
        <border-box slot="sidebar"><h2 v-html="heading"/></border-box>
        <div slot="content">
          <grid-row>
            <div class="worked-section__col">
              <border-box>
                <ul class="worked-section__list">
                  <li
                    v-for="(item, i) in oddItems"
                    :key="i"
                    class="worked-section__item"
                  >
                    <span class="worked-section__name">{{ item.name }}</span>
                    <span class="worked-section__position">
                      {{ item.position }}
                    </span>
                  </li>
                </ul>
              </border-box>
            </div>
            <div class="worked-section__col">
              <border-box xs-hide>
                <ul class="worked-section__list">
                  <li
                    v-for="(item, i) in evenItems"
                    :key="i"
                    class="worked-section__item"
                  >
                    <span class="worked-section__name">{{ item.name }}</span>
                    <span class="worked-section__position">
                      {{ item.position }}
                    </span>
                  </li>
                </ul>
              </border-box>
            </div>
          </grid-row>
        </div>
      </base-layout>
    </div>
  </in-viewport>
</template>

<script>
import BaseLayout from '@/components/BaseLayout'
import BorderBox from '@/components/BorderBox'

export default {
  components: {
    BaseLayout,
    BorderBox
  },
  props: {
    heading: {
      type: String,
      default: ''
    },
    people: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    evenItems () {
      return this.people.filter(person => person.column === 'right')
    },
    oddItems () {
      return this.people.filter(person => person.column === 'left')
    }
  }
}
</script>

<style lang="scss" scoped>
  .worked-section {
    @include vertical-space((bottom: 1));

    &__list {
      @include reset-list;
    }

    &__col {
      @include grid-column((xs: 12, md: 6));

      @include media-up(lg) {
        &:first-child {
          @include nested-column-width(4, 9, lg);
        }

        &:last-child {
          @include nested-column-width(5, 9, lg);
        }
      }
    }

    &__name {
      @include text(big, bold);
    }

    &__position {
      @include text(big, medium);
      display: block;
    }
  }
</style>



// WEBPACK FOOTER //
// src/containers/Team/WorkedSection.vue